<template>
  <div id="exemplarliste">
    <iframe v-if="isopen" :src="src" name="iFrameExemplarliste" id="iFrameExemplarliste"/>
  </div>
</template>
<script lang="ts" setup>
import {computed, ref, watch} from "vue";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";

import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import store from "@km/store";
import {EventListener} from "@k/global/eventVerteiler";
import {INTERFRAMEMESSAGES} from "@k/global/InterframeMessages";


const exemplarlisteFinished = ref(false);


const props = defineProps({
  isopen: Boolean,
  land: String,
  language: String,
  saveid: String,
  tobasket: Boolean
})

new EventListener().addEventListener(INTERFRAMEMESSAGES.EXEMPLARLISTE_CANCEL, () => exemplarlisteFinished.value = true);

const animation = AnimationWaitingForTargetFactory.getUpDownPercentageAnimation("#exemplarliste");
const keyframes = new KeyFrameTargetValues(-100, 0);
watch(() => props.isopen, newVal => {
  animation(newVal ? keyframes.open : keyframes.closed);
  if (!newVal) {
    exemplarlisteFinished.value = false;
  }
});


const src = computed(() => props.isopen ?
    ["/exemplarliste", props.language, props.land, props.saveid, props.tobasket ? "konf_toBasket" : "konf_Save"].join("/")
    : ""
);

</script>

<style scoped lang="scss">

#iFrameExemplarliste {
  width: 100%;
  height: 100%;
}

#exemplarliste {
  background: $color-white;
  overflow: hidden;
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  bottom: -100%;
  z-index: 999;
}
</style>
